export const article = [
  {
    articleId: 15,
    url: "donde-esta-disponible-mega-go",
    category: {
      slug:"comenzar",
      name: "Comenzar"
    },
    title: "¿Dónde está disponible Mega GO? ",
    content: 
      <>
        <div className="row">
          <p>Actualmente Mega GO solo está disponible en Chile.</p>
        </div>
      </>
  }
];